module.exports = __webpack_public_path__ + "static/media/404-500-bg-1.23c2faa8.jpg";